import { applyMiddleware, compose } from 'redux';
import { legacy_createStore as createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
// import socketMiddlewareInit from './middlewares/socket';
import errorHandlerMiddlewareInit from './middlewares/error-handler';
import requestDecoratorMiddlewareInit from './middlewares/request-decorator';
import rootReducer from './reducers';

const configureStore = () => {
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? composeWithDevTools({})
    : compose;

  // preloaded state to hydrate store
  const preloadedState = {};

  const enhancers = composeEnhancers(
    applyMiddleware(
      thunk,
      errorHandlerMiddlewareInit(),
      requestDecoratorMiddlewareInit()
    )
  );

  const store = createStore(rootReducer, preloadedState, enhancers);
  return store;
};

export default configureStore;
